<template>
  <div v-ui-mask="mask" v-ui-loading="pageLoading">
    <ui-heading tag="h4" bold bullet margin>{{
      $t("setNewPasswordTitle")
      }}</ui-heading>
    <ui-v ref="reset-form" :rules="rules">
      <ui-input name="password" type="password" v-model="user.password" :placeholder="$t('typePasswordHere')">
        <ui-icon name="lock" slot="prefix"></ui-icon>
      </ui-input>
      <ui-input name="password2" type="password" v-model="user.password2" :placeholder="$t('repeatPasswordHere')">
        <ui-icon name="lock" slot="prefix"></ui-icon>
      </ui-input>
    </ui-v>
    <ui-button full :disabled="disabled" :loading="loading" type="primary" @click.native="reset">{{
      disabled
      ? $t("passwordResetSuccess") + $t("pleaseWait")
      : $t("resetPassword")
      }}</ui-button>
  </div>
</template>
<script>
import api from "../../api/index";

export default {
  data() {
    return {
      loading: false,
      disabled: false,
      pageLoading: true,
      mask: null,
      user: {
        email: "",
        password: "",
        password2: ""
      },
      rules: {
        password: [{
            type: "required",
            trigger: "submit",
            message: this.$t("empty") + this.$t("password")
          },
          {
            type: "minLength",
            length: 6,
            trigger: "submit",
            message: this.$t("password") + this.$t("tooShort", { len: 6 })
          }
        ],
        password2: [{
            type: "required",
            trigger: "submit",
            message: this.$t("empty") + this.$t("password")
          },
          {
            type: "minLength",
            length: 6,
            trigger: "submit",
            message: this.$t("password") + this.$t("tooShort", { len: 6 })
          },
          {
            type: () => {
              if (this.user.password !== this.user.password2) {
                return false;
              } else {
                return true;
              }
            },
            trigger: "submit",
            message: this.$t("passwordNotSame")
          }
        ]
      }
    };
  },
  methods: {
    reset() {
      this.$refs["reset-form"]
        .validate()
        .then(data => {
          if (this.user.password !== this.user.password2) {
            this.$refs["passwordInput"].error.push(this.$t("passwordNotSame"));
          } else {
            this.resetPassword();
          }
        })
        .catch(err => {});
    },
    resetPassword() {
      this.loading = true;
      api
        .resetPassword({
          pe: this.$route.params.pe,
          pt: this.$route.params.pt,
          pc: this.$route.params.pc,
          password: this.user.password
        })
        .then(data => {
          this.loading = false;
          this.disabled = true;
          this.$UiToast({
            message: this.$t("newPasswordLogin"),
            onClose: () => {
              localStorage.setItem("email", this.user.email);
              this.$router.push("/login?go=index");
            }
          });
        })
        .catch(err => {
          this.loading = false;
          this.$UiToast({
            message: this.$t("resetLinkExpired"),
            type: "warning",
            onClose: () => {
              localStorage.setItem("email", this.user.email);
              this.$router.push("/login?go=index");
            }
          });
        });
    }
  },
  mounted() {
    api
      .resetPasswordDecode(this.$route.params)
      .then(res => {
        this.pageLoading = false;
      })
      .catch(err => {
        this.pageLoading = false;
        if (err.response.data.errorMsg == "expired") {
          this.mask = this.$t("resetLinkExpired");
        } else {
          this.$router.push("/404");
        }
      });
  }
};

</script>
